const projectSearchRouter = {
    path: "project-search",
    name: "project-search",
    meta: {
        title: "项目搜索"
    },
    redirect: {
        name: "project-search-list"
    },
    component: () => import("@/pages/index/home/projectSearch/ProjectSearch"),
    children: [
        {
            path: "project-search-list",
            name: "project-search-list",
            meta: {
                title: "项目搜索-列表页"
            },
            component: () => import("@/pages/itemCommon/List")
        }
    ]
};
export default projectSearchRouter;



// WEBPACK FOOTER //
// ./src/router/index/home/projectSearch.js